import React, { useCallback, useEffect, useState } from "react";
import {
    Button,
    Card,
    Space,
    Typography,
    Breadcrumb,
    Row,
    Col,
    Switch,
    Popover,
} from "antd";
import {
    DeleteOutlined,
    HomeOutlined,
    PlusOutlined,
    InfoCircleOutlined,
    EditOutlined
} from "@ant-design/icons";
import { Spinner } from "reactstrap";
import DataTable from "../../components/CustomDatatable/index.js";
import moment from "moment";
import { stringSorter } from "../../utils/functions.js";
import { useDispatch, useSelector } from "react-redux";
import {
    getItems,
    deleteItem,
    updateItem,
    addItem,
} from "../../store/actions/item.js";
import Swal from "sweetalert2";
import ItemForm from "./ItemForm.js";
import { getCustomers } from "../../store/actions/customers";
import { getPackage } from "../../store/actions/package";
import { getPackageTransaction } from "../../store/actions/packageTransactions.js";

const { Title } = Typography;

const typeOptions = [
    { id: "EWAY", name: "EWAY" },
    { id: "EINVOICE", name: "EINVOICE" },
];

const Items = () => {
    document.title = "Items";
    const [isLoading, setIsLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const dispatch = useDispatch();
    const items = useSelector((state) => state?.item?.list);
    console.log(items, "items");
    const customers = useSelector((state) => state.customers.list);
    const packageTransaction = useSelector(
        (state) => state.packageTransaction.list
    );


    const getData = useCallback(async () => {
        setIsLoading(true);
        await dispatch(getItems());
        setIsLoading(false);
    }, [dispatch]);

    const handleCreate = useCallback(
        async (values) => {
            if (selectedRecord?.id) {
                const updateData = {
                    id: selectedRecord?.id,
                    ...values,
                };
                const res = await dispatch(updateItem(updateData));
                if (res && res.code === 1) {
                    getData();
                }
            } else {
                const res = await dispatch(addItem(values));
                if (res && res.code === 1) {
                    getData();
                }
            }
        },
        [dispatch, selectedRecord?.id]
    );

    const renderCell = (text) => (text ? text : "N/A");

    const content = (
        <div>
            <p>
                This record is linked with the package transaction, you can make your
                edits from that transaction.
            </p>
        </div>
    );
    let columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            sorter: stringSorter("name"),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Front Camera",
            dataIndex: "frontCamera",
            key: "frontCamera",
            sorter: stringSorter("frontCamera"),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Rear Camera",
            dataIndex: "rearCamera",
            key: "rearCamera",
            sorter: stringSorter("rearCamera"),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Processor",
            dataIndex: "processor",
            key: "processor",
            sorter: stringSorter("processor"),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Weight",
            dataIndex: "weight",
            key: "weight",
            sorter: stringSorter("weight"),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Length",
            dataIndex: "length",
            key: "length",
            sorter: stringSorter("length"),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Height",
            dataIndex: "height",
            key: "height",
            sorter: stringSorter("height"),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Display",
            dataIndex: "display",
            key: "display",
            sorter: stringSorter("display"),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "MM Size",
            dataIndex: "mmSize",
            key: "mmSize",
            sorter: stringSorter("mmSize"),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Battery",
            dataIndex: "battery",
            key: "battery",
            sorter: stringSorter("battery"),
            sortDirections: ["ascend", "descend"],
        },
        {
            title: "Display Type",
            dataIndex: "displayType",
            key: "displayType",
            sorter: stringSorter("displayType"),
            sortDirections: ["ascend", "descend"],
        },
        // {
        //     title: "Created At",
        //     dataIndex: "createdAt",
        //     key: "createdAt",
        //     render: (date) =>
        //         moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "",
        //     sorter: (a, b) =>
        //         moment(a.createdAt).isValid() && moment(b.createdAt).isValid()
        //             ? moment(a.createdAt).unix() - moment(b.createdAt).unix()
        //             : 0,
        //     sortDirections: ["ascend", "descend"],
        // },
        // {
        //     title: "Created By",
        //     dataIndex: "createdByName",
        //     key: "createdByName",
        //     sorter: stringSorter("createdByName"),
        //     sortDirections: ["ascend", "descend"],
        //     render: renderCell,
        // },
        // {
        //     title: "Updated At",
        //     dataIndex: "updatedAt",
        //     key: "updatedAt",
        //     render: (date) =>
        //         moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "",
        //     sorter: (a, b) =>
        //         moment(a.updatedAt).isValid() && moment(b.updatedAt).isValid()
        //             ? moment(a.updatedAt).unix() - moment(b.updatedAt).unix()
        //             : 0,
        //     sortDirections: ["ascend", "descend"],
        // },
        // {
        //     title: "Updated By",
        //     dataIndex: "updatedByName",
        //     key: "updatedByName",
        //     sorter: stringSorter("updatedByName"),
        //     sortDirections: ["ascend", "descend"],
        // },
        // {
        //     title: "Status",
        //     dataIndex: "status",
        //     key: "status",
        //     render: (text, record) => (
        //         <Switch
        //             checked={text === 1}
        //         //   onChange={() => handleChangeStatus(record.id, text)}
        //         />
        //     ),
        // },
        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <Space size="middle">

                    <Button
                        type="link"
                        onClick={() => {
                            setSelectedRecord(record);
                            setIsModalVisible(true);
                        }}
                    >
                        <EditOutlined />
                    </Button>
                    <Button
                        danger
                        icon={<DeleteOutlined />}
                        //   onClick={() => handleDelete(record)}
                        onClick={() => {
                            Swal.fire({
                                title: "Are you sure?",
                                text: "You won't be able to revert this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes, delete it!",
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    const res = await dispatch(deleteItem(record.id));
                                    if (res && res.code === 1) {
                                        getData();
                                    }
                                }
                            });
                        }}
                    >
                        {/* Delete */}
                    </Button>
                </Space>
            ),
        },
    ];

    useEffect(() => {
        getData();
    }, [getData]);

    useEffect(() => {
        dispatch(getCustomers());
        dispatch(getPackage());
        dispatch(getPackageTransaction());
    }, [dispatch]);

    return (
        <div className="page-content">
            <Breadcrumb style={{ marginBottom: "16px" }}>
                <Breadcrumb.Item href="/">
                    <HomeOutlined />
                </Breadcrumb.Item>
               <Breadcrumb.Item href="/dashboard">Dashboard</Breadcrumb.Item>
                <Breadcrumb.Item>Items</Breadcrumb.Item>
            </Breadcrumb>

            <Card>
                <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                    <Row justify="space-between" align="middle">
                        <Col>
                            <Title level={2} style={{ margin: 0 }}>
                                Items
                            </Title>
                        </Col>
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => {
                                    setSelectedRecord(null);
                                    setIsModalVisible(true);
                                }}
                            >
                                Add Items
                            </Button>
                        </Col>
                    </Row>
                    {isLoading ? (
                        <div className="d-flex justify-content-center">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <DataTable
                            dataSource={items?.map((item) => ({
                                ...item,
                                key: item?.id,
                                status: item?.status,
                            }))}
                            columns={columns}
                            filterBy={[]}
                            isActive={false}
                        />
                    )}
                </Space>
            </Card>
            <ItemForm
                visible={isModalVisible}
                onCreate={handleCreate}
                onCancel={() => setIsModalVisible(false)}
                record={selectedRecord}
            />
        </div>
    );
};

export default Items;
